import { Button, BackTop, Divider, Form, Input } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

export default function Step4({ ...props }) {
    const { setStep4, editData } = props;
    const { t } = useTranslation(['hr-policy', 'translation']);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep4(true);
                props.nextStep();
            })
            .catch(() => {
                setStep4(false);
                props.nextStep();
            });
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'vendorPurposeTitleTh',
                'vendorPurposeTitleEn',
                'vendorPurposeContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.vendorReasonCollectedData
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep4(check);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData]);

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Reason for collected data')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="vendorReasonCollectedData"
                layout="vertical"
                form={props?.form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'vendorPurposeTitleTh',
                        'vendorPurposeTitleEn',
                        'vendorPurposeContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep4(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('PurposeofCollectPersonalData')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorPurposeTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`บริษัทฯ จะเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่านตามลักษณะความสัมพันธ์ระหว่างบริษัทฯ กับท่าน โดยอาศัยฐานประโยชน์โดยชอบด้วยกฎหมาย ฐานการปฏิบัติตามสัญญา ฐานการปฏิบัติตามกฎหมาย ฐานความยินยอมหรือฐานทางกฎหมายอื่น ๆ ตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด (แล้วแต่กรณี) ทั้งนี้ เพื่อวัตถุประสงค์ดังต่อไปนี้\n\n(1) วัตถุประสงค์ทางธุรกิจ เช่น เพื่อดำเนินธุรกรรมทางธุรกิจกับพันธมิตรทางธุรกิจ และปฏิบัติภาระหน้าที่ และ/หรือปฏิบัติตามคำขอของพันธมิตรทางธุรกิจ เพื่อติดต่อกับพันธมิตรทางธุรกิจเกี่ยวกับสินค้า บริการ และโครงการของบริษัทฯ หรือของพันธมิตรทางธุรกิจ(เช่น เพื่อตอบข้อซักถาม หรือคำขอ)\n\n(2) การคัดเลือกพันธมิตรทางธุรกิจ เช่น เพื่อพิสูจน์ตัวตนของท่านและสถานะของพันธมิตรทางธุรกิจ เพื่อตรวจสอบสถานะกิจการ หรือตรวจสอบประวัติในรูปแบบอื่น ๆ และทำการคัดกรองเกี่ยวกับท่านและพันธมิตรทางธุรกิจ เพื่อประเมินความเหมาะสมและคุณสมบัติของท่านและพันธมิตรทางธุรกิจ เพื่อประเมินความเสี่ยงสำหรับท่านและพันธมิตรทางธุรกิจ (รวมถึงการตรวจสอบข้อมูลที่เปิดเผยต่อสาธารณะจากหน่วยงานบังคับใช้กฎหมาย และ/หรือจากบัญชีรายชื่อ Blacklist ของบริษัทฯ) เพื่อทำคำขอใบเสนอราคาหรือการประมูลราคา เพื่อเข้าทำสัญญา ใบสั่งซื้อ หรือคำขอซื้อกับท่านหรือพันธมิตรทางธุรกิจ และเพื่อประเมินการบริหารงานของท่านและพันธมิตรทางธุรกิจ`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorPurposeContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorPurposeTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`We will collect, use and/or disclose your Personal Data based on the context of your interactions with us by relyingon legitimate interest, contractual basis, legal compliance, consent or other legal bases permitted under the applicable laws concerning personal data protection (as the case may be), for the following purposes:\n\n1) For business purposes, such as to proceed business transactions with business partners and fulfil our duties and/or requests from business partners, to contact business partners regarding products, services and projects of the Company or the business partners (e.g., to respond to questions or requests)\n\n2) For selection of business partners, such as to verify you and status of business partners, to check status of business or perform other background checks and screen you and business partners, to assess your and business partners’ suitability and qualifications, to assess your and business partners’ risks (including the verification of public information from law enforcement agencies and/or the Company’s blacklist record), to prepare quotations or bidding offer, to enter into agreements, prepare purchase orders or purchase requests with you or business partners and to evaluate your and business partners’ management`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorPurposeContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onNextStep}
                                className="ml-4"
                            >
                                {t('policy.NextStep', { ns: 'translation' })}{' '}
                                <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

const initial = {
    vendorReasonCollectedDataId: null,
    vendorPurposeTitleTh:
        'วัตถุประสงค์ในการเก็บรวบรวมใช้เปิดเผยข้อมูลส่วนบุคคล',
    vendorPurposeTitleEn: 'Purpose of collect, use or disclose Personal Data',
    vendorPurposeContentTh: '',
    vendorPurposeContentEn: '',
    vendorPurposeIsDisplay: false,
};
